import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import CardContent from '@mui/material/CardContent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import ProfileTab from './ProfileTab';
import SettingTab from './SettingTab';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import IconButton from 'components/@extended/IconButton';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import avatar1 from 'assets/image/users/avatar-1.png';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../../../../redux/actions/auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { Button, Divider } from '@mui/material';

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`profile-tabpanel-${index}`} aria-labelledby={`profile-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`
  };
}

function stringAvatar(name) {
  if (typeof name !== "string" || name.trim() === "") {
    return { children: "?" };
  }

  return { children: name.trim().split(" ")[0][0].toUpperCase() };
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

export default function Profile() {
  const navigate = useNavigate();
  const dispath = useDispatch();
  const profileData = useSelector((state) => state.auth?.profileData);

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
    toast.success("Logout successfully")
  }

  useEffect(() => {
    dispath(getProfile())
  }, [])

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <ButtonBase
        sx={(theme) => ({
          p: 0.25,
          // bgcolor: open ? 'grey.100' : 'transparent',
          borderRadius: 1,
          // '&:hover': { bgcolor: 'secondary.lighter' },
          '&:focus-visible': { outline: `2px solid ${theme.palette.secondary.dark}`, outlineOffset: 2 },
          ...theme.applyStyles('dark', { bgcolor: open ? 'background.default' : 'transparent', '&:hover': { bgcolor: 'secondary.light' } })
        })}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? 'profile-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center', p: 0.5 }}>
          <Avatar src={`${import.meta.env.VITE_IMAGE_URL}${profileData?.avatar}` || ""}>
            {profileData?.name?.[0] || "A"}
          </Avatar>
          <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
            {profileData?.name}
          </Typography>
        </Stack>
      </ButtonBase>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper sx={(theme) => ({ boxShadow: theme.customShadows.z1, width: 290, minWidth: 240, maxWidth: { xs: 200, md: 200 } })}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Avatar
                        src={`${import.meta.env.VITE_IMAGE_URL}${profileData?.avatar}` || ""}
                        sx={{ width: 50, height: 50 }}
                      >
                        {profileData?.name?.[0] || "A"}
                      </Avatar>
                      <Typography variant="h6" fontWeight={700}>{profileData?.name || "Admin"}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {profileData?.email || "admin@gmail.com"}
                      </Typography>
                    </Box>
                  </CardContent>
                  <Divider sx={{ borderStyle: 'dashed' }} />
                  <ProfileTab close={() => setOpen(false)} />
                  <Divider sx={{ borderStyle: 'dashed' }} />
                  <Box sx={{ p: 1 }}>
                    <Button
                      fullWidth
                      size="medium"
                      variant="text"
                      sx={{ border: "1px solid #B75555", color: "#fff", background: "#B75555", "&:hover": { color: "#fff", background: "#b23b3b" } }}
                      onClick={() => handleLogout()}
                    >
                      Logout
                    </Button>
                  </Box>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box >
  );
}

TabPanel.propTypes = { children: PropTypes.node, value: PropTypes.number, index: PropTypes.number, other: PropTypes.any };
